import React, { Component } from 'react';
import ReactGA from 'react-ga';
import IconButton from '@material-ui/core/IconButton';
import Back from '@material-ui/icons/Undo';
import Typography from '@material-ui/core/Typography';
import ArrowSlider from '../../components/ArrowSlider';
import styles from './OptionsBoardStyles';
import { connect } from 'react-redux';
import ActionTypes from '../../actions/types';
import AdvancedBoardStrikeNear from './AdvancedBoardStrikeNear';
import AdvancedBoardTable from './AdvancedBoardTable';

class AdvancedBoard extends Component {
  render() {
    const {
      rows,
      putVsCall,
      highestEdge,
      highestActual,
      answerArrowPos,
      currentPriceArrowPos,
      latestPrice,
      warnings,
      isMobile,
      strikeValue,
      isChecked,
      toggleShading,
      nearValue,
      strikeWidth,
      changeBidAskMid,
    } = this.props;

    let advancedBoardWidth = '750px';

    const hide =
      (putVsCall === 'Calls' && highestActual.rowIndex === 0) ||
        (putVsCall === 'Puts' && highestEdge.rowIndex === 0)
        ? true
        : false;
    let strikeSliderPosition = 0;

    if (rows && currentPriceArrowPos.rowPos) {
      const rowPos = currentPriceArrowPos.rowPos;
      var strikeDiff = 1;
      if (rows[rowPos + 1]) {
        strikeDiff = rows[rowPos + 1].strike - rows[rowPos].strike;
      } else if (rows[rowPos]) {
        strikeDiff = rows[rowPos].strike - rows[rowPos - 1].strike;
      }
      if (latestPrice && rows[rowPos]) {
        const priceDiff = latestPrice - rows[rowPos].strike;
        strikeSliderPosition = 0.05 + rowPos + priceDiff / strikeDiff;
      }
    }

    const navigateToBasic = () => {
      this.props.setOptionChainStateAction({
        showAdvancedBoard: false,
        showHideStrike: true,
        backFromAdvance: true,
      });
      ReactGA.event({
        category: 'ChainAction',
        action: 'Click Return to Chain',
      });
    };

    return (
      <div>
        <div
          style={
            window.innerWidth > 1800
              ? {
                ...styles.advancedBoardContainer,
                maxWidth: advancedBoardWidth,
              }
              : { ...styles.advancedBoardContainerSmaller }
          }
        >
          <AdvancedBoardStrikeNear
            strikeWidth={strikeWidth}
            isMobile={isMobile}
            strikeValue={strikeValue}
            latestPrice={latestPrice}
            toggleShading={toggleShading}
            isChecked={isChecked}
            nearValue={nearValue}
          />
          <div
            style={
              isMobile
                ? styles.advancedHeaderFlexContainerAdvancedBoardMobile
                : styles.advancedHeaderFlexContainer
            }
            className="sticky"
          >
            <IconButton
              color="primary"
              aria-label="Show Basic Board"
              onClick={navigateToBasic}
            >
              <Back />
            </IconButton>
            <Typography
              variant="inherit"
              component="h3"
              style={{ background: 'black', color: 'white' }}
            >
              {putVsCall}
            </Typography>
          </div>

          <ArrowSlider
            height={highestActual.rowIndex - highestEdge.rowIndex}
            arrowPos={answerArrowPos}
            ref={this.arrowRef}
            hide={hide}
            side="left"
            warnings={isMobile ? null : warnings}
            isMobile={isMobile}
            yStartingPosition={highestEdge.rowIndex}
          />
          <ArrowSlider
            basicPutSingleWarning={true}
            height={highestActual.rowIndex - highestEdge.rowIndex}
            arrowPos={0}
            yStartingPosition={strikeSliderPosition}
            strikeArrow
            advancedStrike
            side="left"
          />
          <ArrowSlider
            basicPutSingleWarning={true}
            height={0}
            arrowPos={0}
            yStartingPosition={strikeSliderPosition}
            strikeArrow
            advancedStrike
            isMobile={isMobile}
            side="right"
          />
          <AdvancedBoardTable
            changeBidAskMid={changeBidAskMid}
            rows={rows}
            highestCallEdge={this.props.highestCallEdge}
            highestEdge={this.props.highestEdge}
            highestActual={this.props.highestActual}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  appState: state.appReducer,
  optionChainState: state.optionChainReducer,
});

const mapDispatchToProps = (dispatch) => ({
  setAppStateAction: (newState) =>
    dispatch({
      type: ActionTypes.SET_APP_STATE,
      payload: newState,
    }),
  setOptionChainStateAction: (newState) =>
    dispatch({
      type: ActionTypes.SET_OPTION_CHAIN_STATE,
      payload: newState,
    }),
});

export default connect(mapStateToProps, mapDispatchToProps)(AdvancedBoard);



// WEBPACK FOOTER //
// ./src/Pages/OptionsBoard/AdvancedBoard.js